<script lang="ts">
	import { NavBar } from '#lib/features/navigation/components/NavBar/index.js';
	import { isGlobalNavHidden } from '#lib/features/navigation/utils/isGlobalNavHidden/isGlobalNavHidden.js';
	import { GlobalSearch } from '#lib/features/search/global/components/GlobalSearch/index.js';
	import { AboutHeader } from '#lib/websites/about/components/AboutHeader/index.js';
	import { page } from '$app/state';
	import { SearchPageContainer } from '$global/features/search/components/SearchPageContainer';
	import { createSearchCombobox } from '$global/features/search/utils/createSearchCombobox';

	interface Props {
		children?: import('svelte').Snippet;
	}

	let { children }: Props = $props();

	const combobox = createSearchCombobox();

	// App-webview visitors (global_nav=0) get the same chrome-free page as
	// /privacy-mobile. The NavBar's app-mode handling only hides the global
	// sections; its desktop bottom bar (logo + search) would still render, and
	// privacy has no platform sub-nav that could justify keeping it.
	let showNavBar = $derived(!isGlobalNavHidden(page.url));
</script>

{#if showNavBar}
	<NavBar dark SearchComponent={GlobalSearch} {combobox} isSearchEnabled={true}>
		{#snippet homeIcon()}
			<AboutHeader />
		{/snippet}
	</NavBar>
{/if}

<SearchPageContainer {combobox}>
	{@render children?.()}
</SearchPageContainer>
